// @flow
import * as React from 'react';
import { useState } from 'react'
import { FormSpy } from 'react-final-form';
import type { FormSpyRenderProps } from 'react-final-form';
import { parseNumber, formatNumber } from '../../../utils/form';
import { getVisibleError } from '../../../hocs/final-form/utils';
import { FormField } from '../../../hocs/final-form';
import classNames from 'classnames/bind';
import Icon from '../../../basic-components/icon';
import Checkbox from '../../../basic-components/checkbox';
import { validCostIsNumberNoSetstate } from '../shipping-packet/shipping-packet-prices';


import Field from '../../../basic-components/field';
import Input from '../../../basic-components/input';
import InputField from '../../../basic-components/input-field';

import cs from './styles.pcss';
import t from '../locale';
import t1 from "../shipping-packet/locale"
const cx = classNames.bind(cs);

type Props = {
  label: string,
  name: string,
  description: React.Node,
  defaultCurrency: string,
  veryLargeScreen?: boolean,
  priceFirstLabel?: string,
  priceAdditionalLabel?: string,
};

export default function PricesNew({
  name,
  label,
  description,
  defaultCurrency,
  veryLargeScreen,
  noLabel = false,
  additionalPriceML10 = false,
  firstDomesticShipping,
  index,
  countryCode,
  onDelete,
  profile,
  fields,
  priceFirstLabel,
  priceAdditionalLabel,
  field,
  freeShipping,
  currentService
}: Props): React.Node {
  const {
    shippingServiceCode,
    shippingCost,
    additionalShippingCost,
    // 国内运送没有ship to
    shipToLocations = null,
  } = currentService || {};
  const [haserror, sethaserror] = useState(false)
  const [errormsg, seterrormsg] = useState("")
  const [priceErrMsg, setpriceErrMsg] = useState("")
  const [priceHasError, setpriceHasError] = useState(false)
  const [additionPriceErrMsg, setadditionPriceErrMsg] = useState("")
  const [additionPricaHasError, setadditionPricaHasError] = useState(false)


  return (

<FormSpy>
{({ form }: FormSpyRenderProps<any>) => {
  let error = null;
  let error1 = null;
  let error2 = null;
  const priceError = getVisibleError(form.getFieldState(`tariffsNew.${countryCode}`));
  if (priceError) {
    const price = form.getFieldState(`${field}.price`);
    const additional = form.getFieldState(
      `${field}.additional_price`
    );

    if(validCostIsNumberNoSetstate(price?.value)===false){
      error1 = t1('price.validate.notNumber');
      error=null;
      error2=null;
    }else if(validCostIsNumberNoSetstate(additional?.value)===false){
      error2 = t1('price.validate.notNumber');
      error=null;
      error1=null;
    }else{
      error1=null
      error2=null
      error =
      price &&
      additional &&
      Number(price?.value || 0) < Number(additional?.value || 0)
        ? t('fields.price.validate.additionalHigher')
        : null;
    }
  }else{
    error1=null
    error2=null
    error =null
  }

  return (
    <div style={{ position: 'relative' }} >
    <Field
      label={label}
      // error={error}
      // errorClassName={cs.errorClassName}
      noLabel={noLabel}
      description={description}
      fieldClassName={cs.fieldClassName}
      descriptionClassName={cs.descriptionClassName}
      noGrid={!veryLargeScreen}
    >
     <div style={{position:'relative'}}>
     <FormField
        name={`${field}.price`}
        Component={Input}
        grid={1}
        className={cs.firstPrice}
        disabled={(fields.value[index]?.free_shipping)||false}
        error={error||haserror||priceHasError||error1}
        onBlur={(e) => {
          let _price = e?.target?.value || 0
          if(validCostIsNumberNoSetstate(_price)==false){
            setpriceErrMsg(t1('price.validate.notNumber'))
            seterrormsg("")
            setpriceHasError(true)
            sethaserror(false)
          }else{
            setpriceHasError(false)
            if ((Number(_price || 0) < Number(fields.value[index]?.additional_price || 0))|| (Number(fields.value[index]?.price || 0) < Number(fields.value[index]?.additional_price || 0))) {
              seterrormsg(t('fields.price.validate.additionalHigher'))
              sethaserror(true)
            }else{
              sethaserror(false)
            }
          }
         
        }}
      />
       {
          (priceHasError && (!error)) && <span style={{  color: '#E62048', position: 'absolute',fontSize: '10px',height:'12px',lineHeight:'12px'}}>   {priceErrMsg}</span>
        }
     </div>

      <div style={{position:'relative'}}>
      <FormField
        name={`${field}.additional_price`}
        Component={Input}
        grid={1}
        className={cs.additionalPrice}
        disabled={(fields.value[index]?.free_shipping)||false}
        error={error||haserror||additionPricaHasError||error2}
        onBlur={(e) => {
          let _additionalPrice = e?.target?.value || 0
          if(validCostIsNumberNoSetstate(_additionalPrice)==false){
            setadditionPriceErrMsg(t1('price.validate.notNumber'))
            setadditionPricaHasError(true)
            seterrormsg("")
            sethaserror(false)
          }else{
            setadditionPricaHasError(false)
            if ((Number(fields.value[index]?.price || 0) < Number(_additionalPrice || 0))||(Number(fields.value[index]?.price || 0) < Number(fields.value[index]?.additional_price || 0))) {
              seterrormsg(t('fields.price.validate.additionalHigher'))
              sethaserror(true)
            }else{
              sethaserror(false)
            }
          }
        }}
      />
       {
          (additionPricaHasError && (!error)) && <span style={{ color: '#E62048', position: 'absolute',fontSize: '10px',left:'10px',height:'12px',lineHeight:'12px'}}>   {additionPriceErrMsg}</span>
        }
      </div>

        {/* error: validation errors displayed when submit */}
        {
          (error) && <span style={{ color: '#E62048', position: 'absolute', bottom: '-20px', fontSize: '10px', width: '400px' }}>   {error}</span>
        }

        {/* haserror: display when failed in onblur validation */}
        {
          (haserror && (!error)) && <span style={{ color: '#E62048', position: 'absolute', bottom: '-20px', fontSize: '10px', width: '400px' }}>   {errormsg}</span>
        }

      <div style={{ visibility: firstDomesticShipping ? "visible" : 'visible', marginLeft: '36px' }}>
        <Checkbox
          key={`${field}.free_shipping`}
          name={`${field}.free_shipping`}
          checked={fields.value[index]?.free_shipping||false}
          onChange={(e) => {
            fields.update(index,{...fields.value[index],
              price: "0",
              additional_price: "0",
              free_shipping: e.target.checked
            })
          }}
        />
      </div>
    </Field>
  </div>
  );
}}
</FormSpy>
  );
}
